import { createContext, useContext, useRef, useState } from 'react';

type ContextProps = {
	options: any[];
	setOptions: (options: any) => void;
	initialOptions: any[];
	setInitialOptions: (options: any) => void;
	selectedIndex: number;
	setSelectedIndex: (index: number) => void;
	selectedOption: any;
	setSelectedOption: (option: any) => void;
	isLoading: boolean;
	setIsLoading: (flag: boolean) => void;
	show: boolean;
	setShow: (flag: boolean) => void;
};

type ContextProviderProps = {
	children: React.ReactNode;
};

const initialValue: ContextProps = {
	options: [],
	setOptions() {},
	selectedIndex: 0,
	setSelectedIndex() {},
	selectedOption: {},
	setSelectedOption() {},
	isLoading: false,
	setIsLoading() {},
	show: false,
	setShow() {},
	initialOptions: [],
	setInitialOptions() {},
};

const InputSelectContext = createContext<ContextProps>(initialValue);

export const InputSelectContextProvider = ({ children }: ContextProviderProps) => {
	const [selectedIndex, setSelectedIndex] = useState(0);
	const [selectedOption, setSelectedOption] = useState({});
	const [options, setOptions] = useState<any[]>([]);
	const [isLoading, setIsLoading] = useState(false);
	const [show, setShow] = useState(false);

	const initialOptionsRef = useRef<any[]>([]);

	const setInitialOptions = (options: any) => {
		initialOptionsRef.current = options;
	};

	return (
		<InputSelectContext.Provider
			value={{
				options,
				setOptions,
				selectedIndex,
				setSelectedIndex,
				selectedOption,
				setSelectedOption,
				isLoading,
				setIsLoading,
				show,
				setShow,
				initialOptions: initialOptionsRef.current,
				setInitialOptions,
			}}
		>
			{children}
		</InputSelectContext.Provider>
	);
};

export const useInputSelectContext = () => useContext(InputSelectContext);
